import {
  AssetRoutineState,
  WorkspaceRoutine,
  useWorkspaceAsset,
  useFindByQuery,
  WorkspaceAsset,
} from '@gripp/shared-logic';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { Colors } from '../../themes/colors';
import { Button } from '../crop-circle/Button';
import { RoutineModule } from '../routine';
import { RoutineModuleButton } from '../routine/components/routineModuleButton';
import { useIssueContext } from './issueContext';
import { messageStyles } from './styles';
import { MessageComponent, MessageComponentProps } from './types';

// TODO: there is a bit of duplication between this component & RoutineButtons

export const RoutinePromptMessage: MessageComponent = (
  props: MessageComponentProps
) => {
  const { t } = useTranslation();
  const context = useIssueContext();
  const subject = context?.assetChatSubject;
  const legacy = useWorkspaceAsset(props.issue.asset?.id, !!subject);
  const scoped = useFindByQuery({
    modelName: 'workspaceAsset',
    query: FIND_PINNED_ROUTINE_STATE,
    variables: {
      filter: {
        id: { eq: subject?.workspaceAssetId },
        workspace: { eq: subject?.workspaceId },
        asset: { eq: subject?.assetId },
      },
    },
    options: { enabled: !!subject && context?.active !== false },
  });
  const candidate = scoped.data?.items?.[0] as WorkspaceAsset | undefined;
  const workspaceAsset = subject
    ? !scoped.isError &&
      !scoped.isFetching &&
      candidate?.id === subject.workspaceAssetId &&
      candidate.workspace?.id === subject.workspaceId &&
      candidate.asset?.id === subject.assetId
      ? candidate
      : undefined
    : legacy.workspaceAsset;
  const [routineState, setRoutineState] = useState<
    AssetRoutineState<any> | undefined
  >();
  const { onRoutineSelected } = context!;

  useEffect(() => {
    if (
      !workspaceAsset ||
      !workspaceAsset.routineState ||
      workspaceAsset.routineState.length === 0
    )
      return;

    const state = workspaceAsset.routineState.find(
      (x) => x.workspaceRoutineId === props.message.promptRoutine.id
    );
    setRoutineState(state);
  }, [props.message.promptRoutine.id, workspaceAsset]);

  const onClick = (
    routine: WorkspaceRoutine,
    module: RoutineModule<any, any>,
    state?: AssetRoutineState<any>,
    additionalState?: any
  ) => {
    if (!workspaceAsset || context?.active === false) return;
    onRoutineSelected({
      workspaceAsset: workspaceAsset!,
      module: module,
      routine,
      state,
      additionalState,
      sourceIssue: props.issue,
    }).catch(console.error);
  };

  return (
    <View>
      <Text style={[messageStyles.messageText, props.textStyle]}>
        {props.message.text}
      </Text>
      {subject && scoped.isError && (
        <Button
          onPress={async () => {
            if (context?.active !== false) {
              try {
                await scoped.refetch({ throwOnError: true });
              } catch (error) {
                console.error(error);
              }
            }
          }}
        >
          {t('chat.feed.retry')}
        </Button>
      )}
      {(!subject || workspaceAsset) && (
        <RoutineModuleButton
          routine={props.message.promptRoutine}
          state={routineState}
          buttonIndex={0}
          buttonCount={1}
          onClick={onClick}
          buttonStyle={styles.buttonStyle}
          labelStyle={styles.labelStyle}
        />
      )}
    </View>
  );
};

const FIND_PINNED_ROUTINE_STATE = `
  query findPinnedRoutineState($filter: WorkspaceAssetFilter) {
    findWorkspaceAssets(filter: $filter) {
      items {
        id
        asset { id name }
        workspace { id type }
        routineState { workspaceRoutineId workspaceRoutineVersionId state }
      }
    }
  }
`;

const styles = StyleSheet.create({
  buttonStyle: {
    maxWidth: 154,
    backgroundColor: Colors.blue,
    borderRadius: 8,
    borderColor: Colors.blue,
    borderWidth: 2,
    height: 44,
    paddingHorizontal: 20,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 16,
  },
  labelStyle: {
    color: Colors.white,
  },
});
